import { compose, pure } from 'recompose';
import { withNamespaces } from 'react-i18next';
import DraggableOverlay from './draggableOverlay';

const enhance = compose(
  pure,
  withNamespaces(['tasks']),
);
export default enhance(DraggableOverlay);
